// hooks/usePolyShiftSettings.js
import { useState, useCallback } from "react";

const defaultSettings = {
  // Fields visible in the UI
  geneType: "all",
  customTranscriptList: "",
  colMin: "",
  colMax: "",
  zscoreCheck: true, // Default checked as per HTML
  onlySigCheck: false, // Default checked as per HTML
  colorPalette: "orange_purple", // Default checked as per HTML
  emailNotification: false,

  // Default values for fields not shown in UI but needed for payload
  plotType: "interactive", // Default from HTML (checked)
  customControlName: "Control",
  customTreatmentName: "Treatment",
  // Other defaults that might be needed for the payload
  geneNo: "",
  minCov: "",
  analysisType: "control",
  selectedSeqType: "riboseq",
  customGeneList: "",
};

export const usePolyShiftSettings = () => {
  const [settings, setSettings] = useState(defaultSettings);

  const updateSetting = useCallback((key, value) => {
    setSettings((prev) => ({
      ...prev,
      [key]: value,
    }));
  }, []);

  const updateMultipleSettings = useCallback((newSettings) => {
    setSettings((prev) => ({ ...prev, ...newSettings }));
  }, []);

  const resetSettings = useCallback(() => {
    setSettings(defaultSettings);
  }, []);

  const validateSettings = useCallback(() => {
    const errors = [];

    if (!settings.geneType) {
      errors.push("Please select a gene type");
    }

    if (
      settings.geneType === "custom" &&
      !settings.customTranscriptList.trim()
    ) {
      errors.push("Please enter a custom transcript list");
    }

    if (!settings.colorPalette) {
      errors.push("Please select a color palette");
    }

    return {
      isValid: errors.length === 0,
      errors,
    };
  }, [settings]);

  return {
    settings,
    updateSetting,
    updateMultipleSettings,
    resetSettings,
    validateSettings,
  };
};
